/* eslint-disable */
import React from 'react';
import {
    TabbedForm,
    TabbedFormTabs,
    useRecordContext,
    useResourceContext,
} from 'react-admin';
import { LearningOutcomesInputs } from './Tabs/LearningOutcomesTabs';
import { CourseTeamInputs } from './Tabs/CourseTeamTabs';
import { CourseInformationInputs } from './Tabs/CourseInformationTabs';
import { CourseSpecificationsInputTab } from './Tabs/CourseSpecificationsTabs';

import { ModulesInputs } from './Tabs/ModulesTabs';
import { EducationalAimsInputsTab } from './Tabs/EducationalAimsTabs';
import { CourseDeliveriesInputTab } from './Tabs/CourseDeliveriesTabs';
import { CourseEIAInputTab } from './Tabs/CourseEIATabs';
import { CourseQualityAssuranceArrangementsInputTab } from './Tabs/CourseQualityAssuranceArrangementsTabs';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { EditToolbar } from '../../layout/EditToolbar';

var titleStyle = { color: '#AE223F' };
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400,
    lineheight: 1,
    letterspacing: 0.00938,
};
const redirect = (basePath, id, data) => `/Course/${id}/show`;

const CourseInputs = (source) => {
    const { canEditCourseAndModule, isSuperAdmin } = useAzureADGroups();
    const record = useRecordContext();
    const resource = useResourceContext();
    // const notify = useNotify();
    if (record) {
        record.versioningType = null;
    }

    const canEdit =
        isSuperAdmin || (resource === 'Course' && canEditCourseAndModule);

    return (
        <ReadOnlyContext.Provider value={!canEdit}>
            <TabbedForm
                {...source}
                redirect={redirect}
                toolbar={<EditToolbar />}
                tabs={
                    <TabbedFormTabs variant="scrollable" scrollButtons={true} />
                }
            >
                <CourseInformationInputs {...source} />
                <CourseDeliveriesInputTab {...source} />
                <ModulesInputs {...source} />
                <CourseTeamInputs {...source} />    
                <EducationalAimsInputsTab {...source} />            
                <LearningOutcomesInputs {...source} />                
                <CourseSpecificationsInputTab {...source} />
                <CourseQualityAssuranceArrangementsInputTab {...source} />                
                <CourseEIAInputTab {...source} />               
            </TabbedForm>
        </ReadOnlyContext.Provider>
    );
};


export const ModuleTitleRenderer = (choice) =>
    `${choice.moduleCode} - ${choice.shortTitle}`;

export default CourseInputs;
